<template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="calc(80% - 0px)" center
        :close-on-click-modal="false" :before-close="handleClose">
        <div>
            <el-form :inline="false" :model="formInline" :rules="rules" ref="rulesForm" label-width="140px" class="form-store">
                <el-form-item label="云环境" prop="cloud">
                    <el-select style="width:170px; margin-right:10px;" v-model.trim="formInline.cloud" clearable>
                            <el-option clearable
                                v-for="item in env_list"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">{{ item.name }}
                            </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备MAC" prop="mac">
                    <el-input v-model.trim="formInline.mac" placeholder="请输入设备MAC地址"></el-input>
                </el-form-item>
                <el-form-item style="text-align: center;">
                    <span>
                        <el-button @click="handleGetDeviceInfo" :loading="loadingPage">获取设备信息</el-button>
                    </span>
                </el-form-item>
            </el-form>
           
            <div>
                <el-form :model="resp" v-if="this.respVisible === true">
                    <el-form-item label="设备状态:" prop="device_status">
                        <span>{{ resp.device_status }}</span>
                    </el-form-item>
                    <el-form-item label="云环境:" prop="cloud">
                        <span>{{ resp.cloud }}</span>
                    </el-form-item>
                    <el-form-item label="设备MAC地址:" prop="mac">
                        <span>{{ resp.mac }}</span>
                    </el-form-item>
                    <el-form-item label="设备公网IP:" prop="device_outter_ip">
                        <span>{{ resp.device_outter_ip }}</span>
                    </el-form-item>
                    <el-form-item label="FIRMWARE:" prop="firmware">
                        <span>{{ resp.firmware }}</span>
                    </el-form-item>
                    <el-form-item style="text-align: center;">
                        <span>
                            <el-button type="primary" @click="submitData" :loading="loadingPage">开启设备远程日志</el-button>
                        </span>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { ENV } from '../../utils/options'

export default {
    components: {

    },
    name: 'RemoteLogDeviceAdd',
    data(){
        return {
            loadingPage: false,
            dialogVisible: false,
            dialogTitle: '',
            formInline: {
                mac: '',
                cloud: '',
            },
            rules: {
                cloud: [
                    { required: true, message: '请选择云环境', trigger: 'blur' }
                ],
                mac: [
                    { required: true, message: '请输入设备mac地址', trigger: 'blur' }
                ],
            },

            respVisible: false,
            resp: {
                mac: '',
                cloud: '',
                device_status: '',
                device_outter_ip: '',
                csmain_outter_ip: '',
                cloud_server_ip: '',
                firmware: '',
            },

            env_list: ENV,

        }
    },
    methods: {
        handleClose() {
            this.dialogVisible = false
            this.loadingPage = false
        },
        deviceAddFlagFn(data, flag){
            this.dialogTitle = flag
            this.dialogVisible=true
            console.log(data)
            
            this.respVisible =false
        },
        handleGetDeviceInfo(){
            let param={
                cloud: this.formInline.cloud,
                mac: this.formInline.mac
            }
            this.loadingPage=true
            this.$http['get']('remote_log_device_info/', param, res=>{
                this.loadingPage=false
                if(res.data.code==200){
                    this.respVisible =true
                    this.resp.mac=this.formInline.mac
                    this.resp.cloud=this.formInline.cloud
                    this.resp.device_status=res.data.data.data.device_status
                    this.resp.device_outter_ip=res.data.data.data.dev_outer_ip
                    this.resp.csmain_outter_ip=res.data.data.data.csmain_outter_ip
                    this.resp.cloud_server_ip=res.data.data.data.cloud_server_ip
                    this.resp.firmware=res.data.data.data.firmware
                }else{
                    this.$message.warning(res.data.msg)
                }
            })
        },
        submitData(){
            let param = {
                csmain_outter_ip: this.resp.csmain_outter_ip,
                mac: this.resp.mac,
                cloud: this.resp.cloud,
                device_outter_ip: this.resp.device_outter_ip,
                firmware: this.resp.firmware
            }
            this.loadingPage=true
            this.$http['get']('remote_log_device_open/', param, res=>{
                this.loadingPage=false
                if(res.data.code == 200){
                    this.$message.success(res.data.msg)
                    this.handleClose()
                    this.$emit('refreshData')
                }else{
                    this.$message.warning(res.data.msg)
                }
            })
        }
    },
    created(){

    }
}
</script>
